// Landing page motion: sections fade in as they scroll into view, and each product
// showcase starts its animation (and counts its numbers up) the first time it is seen.
// Without JavaScript or with reduced motion the page renders in its final state.

const root = document.documentElement;
root.classList.add('landing-js');

const reduceMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
).matches;
const numberFormat = new Intl.NumberFormat('pt-BR');

const countUp = element => {
  const target = Number(element.dataset.count);
  const { prefix = '', suffix = '' } = element.dataset;
  const duration = 1400;
  const start = performance.now();
  const format = value => `${prefix}${numberFormat.format(value)}${suffix}`;
  let done = false;

  const step = now => {
    if (done) return;
    const progress = Math.min(1, (now - start) / duration);
    const eased = 1 - (1 - progress) ** 3;
    element.textContent = format(Math.round(target * eased));
    if (progress < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);

  // Frames pause in background tabs; make sure the number still lands on its final value.
  setTimeout(() => {
    done = true;
    element.textContent = format(target);
  }, duration + 100);
};

// Feature videos play only once their section is on screen; with reduced motion they get
// controls instead of playing on their own.
const startVideos = element => {
  element.querySelectorAll('video[data-landing-video]').forEach(video => {
    if (reduceMotion) {
      video.setAttribute('controls', '');
      return;
    }
    video.play().catch(() => {
      video.setAttribute('controls', '');
    });
  });
};

const show = element => {
  element.classList.add('is-visible');
  if (!reduceMotion) element.querySelectorAll('[data-count]').forEach(countUp);
  startVideos(element);
};

const targets = document.querySelectorAll('.landing-reveal, .landing-spot');

if (reduceMotion || !('IntersectionObserver' in window)) {
  targets.forEach(show);
} else {
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
  );
  targets.forEach(element => observer.observe(element));
}
